<template>
  <div class="fluid-container bg-white">
    <footer>
      <b-row>
        <b-col cols="12" class="text-center text-primary"
          ><a class="algoritmo" href="http://www.algoritmoassociates.com/index.php/it/" target="blank"
            >Powered by Algoritmo Associates</a
          >
          | versione {{ appVersion }}</b-col
        >
      </b-row>
    </footer>
  </div>
</template>

<script>
import {version} from '../../package.json'
export default {
  name: "app-footer",
  data() {
    return {
      appVersion: version,
    };
  },
};
</script>
<style>
footer {
  font-size: 0.9rem;
  color: #757270;
  padding: 0 3rem;
}
.algoritmo {
  color: #f49538 !important;
}
</style>
